import * as React from 'react';
import { style } from 'typestyle';

export const PublishToSalesforceBetaBadge = (): JSX.Element => {
  const badge = (
    <div data-tb-test-id="beta-badge" className={badgeStyle}>
    <div style={textStyle}>Beta</div>
    </div>
  );
  return badge;
};

const BADGE_COLOR = '#858585';
const badgeStyle = style({
    position: 'absolute',
    left: '250px',
    display: 'inline-flex',
    borderRadius: '10%',
    border: `1px solid ${BADGE_COLOR}`,
    padding: '0 8px 0px 8px',
    alignItems: 'center',
  });

  const textStyle: React.CSSProperties = {
    color: BADGE_COLOR,
    fontSize: '12px',
    float: 'right',
    padding: '1px 0 1px 0',
    lineHeight: 'normal',
  };